import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';

const { AddressesApiPathEnum, ServerlessApiPathEnum } = Enums;

export default class AddressApiService {
  static BASE_URL = `/${AddressesApiPathEnum.ADDRESSES}/${ServerlessApiPathEnum.V1}`;

  static async findAddressByParams(params) {
    const [address] = await ServerlessApiService.get(this.BASE_URL, { params });

    return address;
  }

  static async createAddress(address) {
    const [newAddress] = await ServerlessApiService.post(this.BASE_URL, [address]);

    return newAddress;
  }

  static createAddresses(addresses) {
    return ServerlessApiService.post(this.BASE_URL, addresses);
  }
}
